import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

const USER_WITH_ROLE_PATH = 'userWithRole'

export function createOrUpdateWidget(userId, data) {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${USER_WITH_ROLE_PATH}/createOrUpdateWidget`,
            data,
            {
                params: {userId},
            },
        )
        .then(res => res.data)
        .catch(error => console.log(error))
}
